import moment from "moment";

export const DAY = "day";
export const MONTHS = "months";
export const YEAR = "year";
export const YEARS = "years";
export const APRIL = 3;
export const TWELVE = 12;
export const INCEPTION_START_YEAR = 2006;
export const FORMAT = {
    DOT_SEPARATED: "DD.MM.YY",
    SLASH_SEPARATED: "DD/MM/YYYY",
    SLASH_SEPARATED_ABBR_YR: "DD/MM/YY",
    DASH_SEPARATED: "DD-MM-YYYY",
    UTC_DATE_ONLY: "YYYY-MM-DD",
    ISO_DATE_ONLY: "yyyy-MM-dd"
};

export const CURRENT_TAX = {
    id: "CURRENT_TAX_YEAR",
    display: "Current tax year",
    startDate: getStartOfTaxYearFor(now()),
    endDate: now()
};
export const LAST_TAX = {
    id: "LAST_TAX_YEAR",
    display: "Last tax year",
    startDate: getStartOfTaxYearFor(now().subtract(1, YEAR)),
    endDate: getEndOfTaxYearFor(now().subtract(1, YEAR))
};
export const THREE_MONTHS = {
    id: "LAST_3_MONTHS",
    display: "Last 3 months",
    startDate: now().startOf(DAY).subtract(3, MONTHS),
    endDate: now()
};
export const SIX_MONTHS = {
    id: "LAST_6_MONTHS",
    display: "Last 6 months",
    startDate: now().startOf(DAY).subtract(6, MONTHS),
    endDate: now()
};
export const TWELVE_MONTHS = {
    id: "LAST_12_MONTHS",
    display: "Last 12 months",
    startDate: now().startOf(DAY).subtract(TWELVE, MONTHS),
    endDate: now()
};
export const THREE_YEARS = {
    id: "LAST_3_YEARS",
    display: "Last 3 years",
    startDate: now().startOf(DAY).subtract(3, YEARS),
    endDate: now()
};
export const FIVE_YEARS = {
    id: "LAST_5_YEARS",
    display: "Last 5 years",
    startDate: now().startOf(DAY).subtract(5, YEARS),
    endDate: now()
};
export const ALL_DATES = {
    id: "ALL_DATES",
    display: "All dates",
    startDate: inception(),
    endDate: now()
};

export const DATE_OPTIONS_LIST = [
    CURRENT_TAX,
    LAST_TAX,
    THREE_MONTHS,
    SIX_MONTHS,
    TWELVE_MONTHS,
    THREE_YEARS,
    FIVE_YEARS,
    ALL_DATES
];

export function convertIdToReal(id) {
    const dateRange = DATE_OPTIONS_LIST.find(opt => opt.id === id) || {};
    return { ...dateRange };
}

export function getDefaultAnalysisDateRange() {
    return { ...TWELVE_MONTHS };
}

export function getDefaultDocumentsDateRange() {
    return { ...ALL_DATES };
}

export function getRangeStringFromId(id, dateFormat) {
    const real = convertIdToReal(id);
    return `${format(real.startDate, dateFormat)} - ${format(real.endDate, dateFormat)}`;
}

export function getStartOfTaxYearFor(date) {
    return moment({ year: getTaxYear(date), month: APRIL, day: 6 }).startOf(DAY);
}

export function getEndOfTaxYearFor(date) {
    return moment({ year: getTaxYear(date) + 1, month: APRIL, day: 5 }).endOf(DAY);
}

export function getTaxYear(date) {
    return isBeforeSixthApril(date) ? date.clone().subtract(1, YEAR).year() : date.year();
}

export function getCurrentTaxYear() {
    return getTaxYear(now());
}

function isBeforeSixthApril(date) {
    const beforeApril = date.month() < APRIL;
    const inApril = date.month() === APRIL;
    const before6thOfMonth = date.date() < 6;
    return beforeApril || (inApril && before6thOfMonth);
}

export function format(date, format = FORMAT.DOT_SEPARATED) {
    return date ? moment(date).format(format) : "";
}

export function now() {
    return moment.utc();
}

export function inception() {
    return now().year(INCEPTION_START_YEAR).startOf(YEAR);
}

export function convertArrayToDateString(array) {
    return array.map(item => (item <= 9 ? `0${item}` : `${item}`)).join("-");
}

export const locale = {
    format: "DD/MM/YYYY",
    monthNames: moment.months(),
    firstDay: 1,
    separator: " - ",
    applyLabel: "Apply",
    cancelLabel: "Cancel",
    fromLabel: "From",
    toLabel: "To",
    customRangeLabel: "Custom",
    weekLabel: "W",
    daysOfWeek: moment.weekdaysMin(),
    direction: "ltr"
};
